import { useEffect } from "react";

const TypeHidden = ({ field, updateValidationOnChange }) => {
  useEffect(() => {
    updateValidationOnChange([field.key], field.value);
  }, []);
};

export default TypeHidden;
